module.exports = __webpack_public_path__ + "static/media/Artboard20.3e7a9e7d.png";